/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OAuthAppTypeEnum = 'NATIVE' | 'SRM_AGENT' | 'ASUP' | 'VCF' | 'VMC' | 'VMC_POOL' | 'DRC';

export const OAuthAppTypeEnum = {

    NATIVE: 'NATIVE' as OAuthAppTypeEnum,

    SRM_AGENT: 'SRM_AGENT' as OAuthAppTypeEnum,

    ASUP: 'ASUP' as OAuthAppTypeEnum,

    VCF: 'VCF' as OAuthAppTypeEnum,

    VMC: 'VMC' as OAuthAppTypeEnum,

    VMC_POOL: 'VMC_POOL' as OAuthAppTypeEnum,

    DRC: 'DRC' as OAuthAppTypeEnum
};

